import { FiscalInvoices } from './FiscalInvoices';

/** KSeF invoice list — real table + retry/xml/upo/qr actions (Task 14). */
export function FiscalInvoicesPage() {
  return <FiscalInvoices />;
}
